export default __webpack_public_path__ + "static/media/profilePlaceholder.c35bb336.jpg";